import React from 'react';
import Header from './../../components/header';
import FaqsBody from './body';
import Footer from '../../components/footer';

function Faqs(props) {
    document.title = `Yebokenny Frequency Asked Questions`;
    return (
        <div>
            <Header></Header>
            <FaqsBody></FaqsBody>
            <Footer></Footer>
        </div>
    );
}

export default Faqs;